import React, { Component } from 'react';
import Menu from './components/Menu';
import Tenemos from './components/Tenemos';
import Experiencia from './components/Experiencia';
import Descripcion from './components/Descripcion';
import Productos from './components/Productos';
import Personalizados from './components/Personalizados';
import Empresas from './components/Empresas';
import './js/Eventoclick.js';
import './css/iconosubir.css';
import './js/EventoProductos.js';
import Manuales from './components/Manuales';
import Nosotros from './components/Nosotros';
import Contactos from './components/Contactos';
import Politicas from './components/politicas';

class App extends Component {

  render() {
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/es_LA/sdk/xfbml.customerchat.js#xfbml=1&version=v2.12&autoLogAppEvents=1';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));


    return (
      <div>
        <Menu />
        <a href='#' id="boton-subir" class="boton-subir">
          <i class="fa fa-rocket" aria-hidden="true"></i>
        </a>
        <Tenemos />
        <Experiencia />
        <Descripcion />
        <Productos />
        <Personalizados />
        <Empresas />
        <Manuales />
        <Nosotros />
        <Politicas/>
        <Contactos />
        <div id="fb-root"></div>
        <div class="fb-customerchat"
          attribution="setup_tool"
          page_id="1889497431165921"
          theme_color="#0084ff"
          logged_in_greeting="Hola! Como podemos ayudarte?"
          logged_out_greeting="Hola! Como podemos ayudarte?">
        </div>
      </div>


    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js